/** Responsive src/srcSet helpers for images served by /api/media (supports ?w=480|800|1200). */
const WIDTHS = [480, 800, 1200];

const isMedia = (src) => typeof src === "string" && src.includes("/api/media/");
const withW = (src, w) => `${src}${src.includes("?") ? "&" : "?"}w=${w}`;

export function responsive(src, sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw") {
  if (!isMedia(src)) return { src };
  return { src: withW(src, 800), srcSet: WIDTHS.map((w) => `${withW(src, w)} ${w}w`).join(", "), sizes };
}
